export default __webpack_public_path__ + "static/img-1-b1dd68d42e26f41b5d867ce5110e9d50.png";